<script setup lang="ts" generic="Value extends string[] | null">
import { computed } from 'vue';
import { InputTags } from '@kiplin/web-common/design-system';
import FormFieldMessages from '@shared/common/form/application/component/FormFieldMessages.vue';
import type { FormField } from '@shared/common/form/domain/form/field/base.form-field';

const model = defineModel<FormField<Value>>({ required: true });

const message = computed(() => model.value.errorMessages?.[0]);
const additionalErrors = computed(() => model.value.errorMessages?.slice(1));
const allowDuplicates = computed(() => model.value.meta?.allowDuplicates !== false);
const tagsModel = computed<string[]>({
  get: () => model.value.value ?? [],
  set: (value: string[]) => {
    model.value.value = value as never;
  },
});
</script>

<template>
  <div>
    <InputTags
      v-model="tagsModel"
      :label="model.label"
      :hint="model.hint"
      :placeholder="model.placeholder"
      :disabled="model.disabled"
      :readonly="model.readonly"
      :message="message"
      :error="message"
      :allow-duplicates="allowDuplicates"
    />
    <FormFieldMessages :errors="additionalErrors" />
  </div>
</template>
